<template>
  <div class="equipMain" ref="container">

    <div class="search-form">
      <div class="select-box" @click="showPicker = true">
        <div class="show-item">
          <div class="name">{{ sitName }}</div>
          <img class="icon" src="@/assets/image/icon/lower.png">
        </div>
        <!--        <div class="picker-box">-->
        <!--          <div class="picker-item" @click.stop="confirmPicker(item)" v-for="(item,index) in options[0]"-->
        <!--               :key="`picker-item_${index}`">-->
        <!--            {{ item.value }}-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
    <isEmpty v-if="pileResults.length === 0">
      <div slot="desc" class="is-empty_desc">
        <div class="is-empty_desc-title">
          您还没有添加充电桩
        </div>
        <div class="is-empty_descript">
          <p>请点击下方 ’添加充电桩‘ 按钮</p>
          <p>开始您的运营之旅吧！</p>
        </div>
      </div>
    </isEmpty>
    <div class="content" v-else>
      <div class="content-title">全部设备<span>{{ total }}</span></div>
      <mu-load-more
          @refresh="refresh"
          :refreshing="refreshing"
          :loaded-all="loaded_all"
          :loading="loading"
          @load="load"
      >
        <div class="list-box">
          <div class="list-item" v-for="(item, index) in pileResults"
               :key="index">
            <div class="header-info">
              <div class="no">{{ item.id }}</div>
              <div class="state-box" v-if="item.runningStatus == '0'">
                <img class="icon" src="@/assets/image/mine/index/online.png"/>
                <div class="state state-online">运行</div>
              </div>
              <div class="state-box" v-else>
                <img class="icon" src="@/assets/image/mine/index/offline.png"/>
                <div class="state state-offline">离线</div>
              </div>
            </div>
            <div class="data-info">
              <div class="data-item">
                总收益：{{ handleControlNumber(item.pileIncomeVO.orderGold || 0, 2) }}元
              </div>
              <div class="data-item">
                已充电量：{{ handleControlNumber(item.pileIncomeVO.consumePower || 0, 2) }}度
              </div>
              <div class="data-item">
                充电次数：{{ item.pileIncomeVO.chargeTimes }}
              </div>
              <div class="data-item">
                充电时长：{{ handleControlNumber(item.pileIncomeVO.realHour, 2) }}小时
              </div>
            </div>
            <div class="options">
              <div class="options-item"
                   v-for="(btn, sindex) in buttonList"
                   :key="sindex"
                   @click="collButtonClick(item, btn, sindex)"
              >{{ btn.label }}
              </div>
            </div>
          </div>
        </div>
      </mu-load-more>
    </div>
    <nut-dialog
        title="规则设置"
        :visible="ruleVisible"
        @ok-btn-click="dialogConfirm"
        @cancel-btn-click="dialogCancel">
      <el-form
          :model="form"
          ref="form"
          size="normal"
          label-position="left"
          label-width="80px"
          style="overflow: hidden;"
      >
        <el-form-item label="选择规则">
          <el-select
              v-model="ruleActiveTitle"
              placeholder="请选择规则"
              class="cardSelect"
              style="width: 100%;"
              @focus="SelectRules()"
          >
          </el-select>
        </el-form-item>
      </el-form>
    </nut-dialog>

    <nut-picker
        :is-visible="showRulesPicker"
        :list-data="rulesOptions"
        @close="showRulesPicker = false"
        @confirm="confirmRules"
    ></nut-picker>
    <nut-picker
        :is-visible="showPicker"
        :list-data="options"
        @close="closePicker"
        @confirm="confirmPicker"
    ></nut-picker>
    <AddOperate @click="addPush"></AddOperate>
  </div>
</template>
<script>
//引入字典表
import {runningStatus} from "@/dictionary/dictionary";
import {Toast} from "vant";
import {
  getPlotList,
  getEquipList,
  setPileRule,
  getRuleList,
} from "@/api/newApi";
import {digitUtil} from "@/utils/utils"

import AddOperate from "@/components/add-operate/index.vue";

export default {
  components: {AddOperate},
  data() {
    return {
      form: {},
      sitName: "全部",
      sitId: null,
      showPicker: false,
      options: [],
      nolist: true,
      nums: 1,
      loaded_all: false,
      refreshing: false,
      loading: false,
      runningStatus: runningStatus,
      buttonList: [
        {
          label: "端口管理",
          icon: require("@/assets/image/svg/equipmentManager/port.png"),
        },
        {
          label: "规则管理",
          icon: require("@/assets/image/svg/equipmentManager/guize.png"),
        },
        {
          label: "查看收益",
          icon: require("@/assets/image/svg/equipmentManager/shouyi.png"),
        },
        {
          label: "编辑",
          icon: require("@/assets/image/svg/equipmentManager/edit.png"),
        },
      ],
      ruleVisible: false,
      showRulesPicker: false,
      rulesOptions: [],
      rulesList: [],
      cardList: [],
      num: 999,
      ruleActiveTitle: "",
      rule: {
        cardRuleId: null,
        wxRuleId: null,
      },
      sbId: null,
      total: 0,
      pileResults: [],
      pages: 0,
    };
  },
  watch: {
    sitId: {
      deep: true,
      immediate: true,
      handler(val) {
        this.nums = 1;
        this.pileResults = [];
        this.changeCollapse(val);
      },
    },
  },
  mounted() {
    this.getChargingList({pageNo: 1, pageSize: this.num, deviceType: 4});
    getRuleList({deviceType: 4, pageNo: 1, pageSize: this.num}).then(
        (res) => {
          this.rulesList = res.data.records;
          this.rulesOptions = [
            res.data.records.map((item) => {
              return {
                label: item.id,
                value: item.changeName,
              };
            }),
          ];
        }
    );
  },
  methods: {
    handleControlNumber: digitUtil,
    load() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.nums += 1;
        if (this.nums <= this.pages) {
          this.changeCollapse(this.sitId);
        }
      }, 2000);
    },

    refresh() {
      this.refreshing = true;
      this.$refs.container.scrollTop = 0;
      this.nums = 1;
      this.pileResults = [];
      setTimeout(() => {
        this.refreshing = false;
        this.changeCollapse(this.sitId);
      }, 1000);
    },
    changeCollapse(even) {
      getEquipList({
        pageNo: this.nums,
        pageSize: 5,
        deviceType: 4,
        plot: even,
      }).then((res) => {
        if (res.message.code == 0) {
          this.total = res.data.total;
          this.pages = res.data.pages;
          res.data.records.forEach((item) => {
            this.pileResults.push(item);
          });
          if (res.data.pages == this.nums) {
            Toast("已加载全部数据");
            this.loaded_all = true;
          }
        }
      });
    },
    Select() {
      this.showPicker = true;
    },
    closePicker() {
      this.showPicker = false;
      console.log(this.showPicker)
    },
    confirmPicker(even) {
      this.sitName = even[0].value;
      this.sitId = even[0].label;
      this.closePicker()
      this.$forceUpdate()
    },
    SelectRules() {
      this.showRulesPicker = true;
    },
    confirmRules(data) {
      this.ruleActiveTitle = data[0].value;
      this.rule.wxRuleId = data[0].label;
      this.showRulesPicker = false;
    },
    addPush() {
      this.$router.push({
        path: "/admin/equipadd",
      });
    },
    getChargingList(param) {
      this.options = [];
      getPlotList(param).then((res) => {
        if (res.data != "") {
          if (res.message.code == 0) {
            let list = res.data.records.map((item) => {
              return {
                label: item.id,
                value: item.plotName,
              };
            });
            list.unshift({
              label: "",
              value: "全部",
            });
            this.options = [list];
          }
        } else {
          Toast("暂无数据");
        }
      });
    },
    collButtonClick(items, itemx, index) {
      localStorage.setItem("EQUIP_DETAIL", JSON.stringify(items))
      switch (index) {
        case 0:
          this.port(items.id);
          break;
        case 1:
          // this.ruleVisible = !this.ruleVisible;
          // this.sbId = items.id;
          // this.rule.cardRuleId = items.cardRuleId;
          // this.rule.wxRuleId = items.wxRuleId;
          // this.ruleActiveTitle = this.rulesList.find(
          //     (val) => val.id == items.wxRuleId
          // ).changeName;
          this.$router.push({
            path: `/admin/rules-select?id=${items.id}&wxRuleId=${items.wxRuleId}`,
          });
          break;
        case 2:
          this.shouyi(items.id);
          break;
        case 3:
          this.editHandler(items);
          break;
        default:
          break;
      }
    },
    editHandler(items) {
      console.log(items);
      this.$router.push({
        path: "/admin/equipadd",
        query: items,
      });
    },
    port(id) {
      this.$router.push({
        path: "/admin/port/" + id,
      });
    },
    shouyi(id) {
      this.$router.push({
        path: "/admin/ordersales",
        query: {
          id: id,
        },
      });
    },
    dialogCancel() {
      this.ruleVisible = !this.ruleVisible;
    },
    dialogConfirm() {
      var that = this;
      setPileRule({
        Id: this.sbId,
        wxRuleId: this.rule.wxRuleId,
        cardRuleId: this.rule.cardRuleId,
      }).then((res) => {
        if (res.message.code == 0) {
          Toast("设置规则成功");
          that.changeCollapse(that.sitId);
          that.ruleVisible = !that.ruleVisible;
        }
      });
    },
    selectRule(data) {
      this.ruleActiveTitle = data.changeName;
      this.rule.wxRuleId = data.id;
      this.$refs.item.toggle();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.equipMain {
  //padding: 0.2667rem 0.4rem 1.76rem;
  min-height: calc(100vh - 1.8rem);
  background-color: #F5F5F6;
  position: relative;

  .search-form {
    padding: 0.3rem $divPadding;
    height: 1.684375rem;
    width: 100%;
    box-sizing: border-box;
    background-color: white;


    .search-input_actived {
      transition: all .3s ease;
      background-color: #F5F5F5;
      transform: scale(1.01);
      box-shadow: 0 4px 0.2rem 4px rgba(0, 0, 0, 0.3);
      overflow: hidden;
      position: absolute;
      z-index: 80;
      width: calc(100% - ($divPadding * 2));

      .picker-box {
        transition: all .3s ease;
        background-color: #F5F5F5 !important;
        max-height: 4.5rem;
        height: auto;
      }
    }

    .picker-box {
      width: 100%;
      height: 0;

      overflow: scroll;

      .picker-item {
        padding: 0.3rem;
        position: relative;

        &:before {
          content: '';
          position: absolute;
          width: 95%;
          height: 1px;
          left: 0;
          right: 0;
          bottom: 0;
          margin: 0 auto;
          background-color: #DDDDDD;
        }
      }
    }

    .select-box {
      border-radius: $borderRadius;
      background-color: #F5F5F5;

      .show-item {
        display: flex;
        justify-content: space-between;
        box-sizing: content-box;
        padding: 0.3rem;
      }

      .name,
      .icon {
        align-self: center;
      }

      .name {
        color: #666666;
        font-size: $fontSize_12;
      }

      .icon {
        width: 0.1921rem;
        height: 0.1651rem;
        margin-right: 0.1rem;
      }
    }

  }

  .content {
    padding: 0 $divPadding;

    .content-title {
      padding: 0.3rem 0;
      font-size: $fontSize_14;
      color: #666666;

      span {
        color: #3D3D3D;
        margin-left: 0.1rem;
        font-weight: bold;
      }
    }

    .list-box {
      .list-item {
        margin-bottom: 0.3rem;
        border-radius: $borderRadius;
        background-color: white;
        padding: $divPadding;

        .header-info {
          display: flex;
          justify-content: space-between;
          padding-bottom: 0.2rem;
          border-bottom: 1px solid #ECECEC;

          .no {
            font-size: $fontSize_14;
            color: #3D3D3D;
          }

          .no,
          .icon,
          .state {
            align-self: center;
          }

          .state-box {
            display: flex;

            .icon {
              width: 0.4413rem;
              height: 0.3702rem;
            }

            .state {
              margin-left: 0.1rem;
              font-size: $fontSize_10;
            }

            .state-online {
              color: #386DE6;
            }

            .state-offline {
              color: #a2a2a2;
            }
          }
        }

        .data-info {
          margin-top: 0.2rem;
          display: flex;
          flex-wrap: wrap;

          .data-item {
            width: 50%;
            box-sizing: border-box;
            padding: 0.1rem;
            padding-left: 0.3rem;
            position: relative;
            font-size: $fontSize_12;
            color: #888888;

            &:before {
              content: '';
              position: absolute;
              width: 0.1621rem;
              height: 0.1621rem;
              top: 0;
              bottom: 0;
              left: 0;
              border-radius: 50rem;

              margin: auto 0;
            }

            &:nth-child(1):before {
              background-color: #EC933D;
            }

            &:nth-child(2):before {
              background-color: #50C06A;
            }

            &:nth-child(3):before {
              background-color: #8EA8E3;
            }

            &:nth-child(4):before {
              background-color: #8EA8E3;
            }
          }
        }

        .options {
          margin-top: 0.3267rem;
          display: flex;
          justify-content: space-between;

          .options-item {
            border: 1px solid transparent;
            font-size: $fontSize_12;
            padding: 0.15rem 0.3rem;
            border-radius: 0.0810rem;
          }

          .options-item:nth-child(1) {
            color: #7595CC;
            border-color: #7595CC;
          }

          .options-item:nth-child(2) {
            color: #7FC991;
            border-color: #7FC991;
          }

          .options-item:nth-child(3) {
            color: #DC9959;
            border-color: #DC9959;
          }

          .options-item:nth-child(4) {
            color: #7D899D;
            border-color: #7D899D;
          }
        }
      }
    }
  }


  // 以上是新样式

  .info-box-length {
    margin: 0.2778rem 0.3467rem;
    font-size: 0.3733rem;
    color: #000000;
  }

  .equip-list-box {
    .equip-item {
      margin-bottom: 0.2367rem;
      background: #ffffff;
      border-radius: 0.1867rem;
      padding: 0.32rem;

      .item-title-box {
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
          width: 0.3733rem;
          height: 0.3733rem;
        }

        span {
          margin-right: 0.2667rem;
          font-size: 0.4267rem;
          font-weight: 600;
          color: #000000;
        }

        .status {
          font-size: 0.32rem;
        }
      }

      .item-center-box {
        margin-top: 0.2667rem;
        padding: 0.32rem 0.5867rem;
        background: #f5f5f5;
        border-radius: 0.1867rem;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .center-info {
          width: 50%;
          font-size: 0.4rem;
          color: #666666;
          line-height: 0.5867rem;
        }
      }

      .item-bottom-box {
        margin-top: 0.2667rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .btn-box {
          width: 1.8933rem;
          height: 0.7467rem;
          text-align: center;
          line-height: 0.7467rem;
          border: 1px solid #134fc5;
          border-radius: 0.3467rem;
          font-size: 0.32rem;
          color: #3961b2;
        }
      }
    }
  }

}
</style>
